export const FILTER_AGENCIES = 'agencyIds';
export const FILTER_MASTER_CAMPAIGNS = 'masterCampaignIds';
export const FILTER_INFLUENCERS = 'influencerIds';
export const FILTER_CATEGORIES = 'categoryIds';
export const FILTER_SUB_CATEGORIES = 'subCategoryIds';
export const FILTER_SOCIAL_MEDIA_PLATFORMS = 'socialMediaPlatformIds';
export const FILTER_COUNTRIES = 'countryCodes';
export const FILTER_APPLICATIONS = 'applicationIds';

export const FILTERS_DEPENDENCIES = {
  [FILTER_SUB_CATEGORIES]: [FILTER_CATEGORIES],
};

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_AGENCIES = 'agencies';
export const COLUMN_INFLUENCER = 'influencer';
export const COLUMN_COUNTRY = 'country';
export const COLUMN_SOCIAL_MEDIA_PLATFORM = 'socialMediaPlatform';
export const COLUMN_CATEGORY = 'category';
export const COLUMN_SUB_CATEGORY = 'subCategory';
export const COLUMN_MASTER_CAMPAIGNS = 'masterCampaigns';
export const COLUMN_TA = 'targetAudience';
export const COLUMN_VIEWS_MIN = 'viewsMin';
export const COLUMN_VIEWS_MAX = 'viewsMax';
export const COLUMN_CPM_MIN = 'cpmMin';
export const COLUMN_CPM_MAX = 'cpmMax';
export const COLUMN_ENGAGEMENT = 'engagementRate';
export const COLUMN_CLICKS_MIN = 'clicksMin';
export const COLUMN_CLICKS_MAX = 'clicksMax';
export const COLUMN_CPI_MIN = 'cpiMin';
export const COLUMN_CPI_MAX = 'cpiMax';
export const COLUMN_CONVERSIONS_MIN = 'conversionsMin';
export const COLUMN_CONVERSIONS_MAX = 'conversionsMax';
export const COLUMN_CONCURRENT_VIEWERS = 'concurrentViewers';

export const COLUMN_PRICES = 'prices';
export const COLUMN_PRICES_WITH_FEE = 'pricesWithFee';
export const COLUMN_SUBSCRIBERS = 'subscribers';
export const COLUMN_OWNER = 'owner';
export const COLUMN_LAST_UPDATED_BY = 'updatedBy';
export const COLUMN_LAST_UPDATED_DATE = 'updated';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'created';
export const ACTION_EDIT = 'Edit';
export const ACTION_DELETE = 'Delete';

export const TEMPLATE_NEW_INFLUENCER_CHANNEL = 'newInfluencerChannel';
export const TEMPLATE_NEW_INFLUENCER_CATEGORIES = 'newCategories';
